import React from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/Modal';


import autoTransmission from '../../images/auto-transmission.svg';
import manualTransmission from '../../images/manual-transmission.svg';

const TransmissionMoadl = ({
  isOpen, toggleTransmisionModal, selectTransmissionHandl, selectedTransmission
}) => (
  <Modal isOpen={isOpen}>
    <div className="car-header  -text">
      <button onClick={toggleTransmisionModal} className="car-back">
		  Cancel
      </button>
      <p className="car-title">
		  Transmission
      </p>
      <button onClick={toggleTransmisionModal} className="car-select">
		  Select
      </button>
    </div>
    <div className="car-detail">
      <button className="detail-item" onClick={selectTransmissionHandl('auto')}>
        <i className="item-img" style={{ backgroundImage: `url(${autoTransmission})` }} />
        <span className="item-text">
		  Automatic Transmission
        </span>
        {
		  selectedTransmission === 'auto' ? <i className="material-icons -check">check</i> : null
		}
      </button>
      <button className="detail-item" onClick={selectTransmissionHandl('manual')} >
        <i className="item-img" style={{ backgroundImage: `url(${manualTransmission})` }} />
        <span className="item-text">
		  Manual Transmission
        </span>
        {
		  selectedTransmission === 'manual' ? <i className="material-icons -check">check</i> : null
		}
      </button>
    </div>
  </Modal>
);


TransmissionMoadl.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  selectTransmissionHandl: PropTypes.func.isRequired,
  toggleTransmisionModal: PropTypes.func.isRequired,
  selectedTransmission: PropTypes.string.isRequired
};


export default TransmissionMoadl;




// WEBPACK FOOTER //
// ./src/pages/CarPage/components/TransmissionModal/index.js